import type { HeadingTagType } from '@lexical/rich-text'
import type { LexicalCommand } from 'lexical'
import { createCommand } from 'lexical'
import type { StrategyBasedInsertContentItemSource } from '../../types/content-items'
import type { AdamNoteNode } from './nodes/AdamNoteNode/AdamNoteNode'

interface InsertAdamNotePayload {
    source: StrategyBasedInsertContentItemSource
    createNote: (payload?: { id?: string }) => AdamNoteNode
}

const INSERT_ADAM_NOTE_COMMAND: LexicalCommand<InsertAdamNotePayload> =
    createCommand('INSERT_ADAM_NOTE_COMMAND')

const INSERT_ADAM_PARAGRAPH_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    payload?: Partial<{ id?: string }>
}>('INSERT_ADAM_PARAGRAPH_COMMAND')

const INSERT_ADAM_HEADING_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    tag: HeadingTagType
    payload?: Partial<{ id?: string }>
}>('INSERT_ADAM_HEADING_COMMAND')

const INSERT_ADAM_QUOTE_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    payload?: Partial<{ id?: string }>
}>('INSERT_ADAM_QUOTE_COMMAND')

export {
    type InsertAdamNotePayload,
    INSERT_ADAM_NOTE_COMMAND,
    INSERT_ADAM_PARAGRAPH_COMMAND,
    INSERT_ADAM_HEADING_COMMAND,
    INSERT_ADAM_QUOTE_COMMAND,
}
